<template>
    <b-container fluid class="p-0">
        <b-row>
            <b-col sm="12" class="mb-0 pb-0">
                <div>
                    <div class="row d-flex flex-row">
                        <div class="col-4 text-left">
                            <p class="mb-0">
                                <span class="">Modifier Group Name</span>
                            </p>
                            <p class="mb-0 text-muted">
                                <span>{{selectedModifierName}}</span>
                            </p>
                        </div>
                        <div class="col-4 text-left">
                            <p class="mb-0">
                                <span class="">Type</span>
                            </p>
                            <p class="mb-0 text-muted">
                                <span v-if="selectedModifierOptional === 1">Optional</span>
                                <span v-else>Required</span>
                            </p>
                        </div>
                        <div class="col-4 text-left">
                            <p class="mb-0">
                                <span class="">Rule</span>
                            </p>
                            <p class="mb-0 text-muted">
                                <span>{{selectedModifierChoiceOption}}</span>
                                <span class="mx-2">{{selectedModifierChoiceNumber}}</span>
                            </p>
                        </div>
                    </div>

                    <b-table-simple class="mt-3" v-if="currentModifier.length" striped borderless>
                        <b-thead>
                            <b-tr class="bg-gray-300">
                                <b-th>Modifier Name</b-th>
                                <b-th>Comment</b-th>
                                <b-th>Add'l Price</b-th>
                                <b-th></b-th>
                            </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr v-for="item in currentModifier" class="cursor-pointer" :class="item.selected && 'selectedModifier'" @click="selectModifer(item)">
                                <b-td>
                                    <span>{{item.ModifierName}}</span>
                                    <span class="mx-3" style="color: #78909C" v-if="AllowSecondLang && item.ModifierName_SecondLang !== ''">{{item.ModifierName_SecondLang}}</span>
                                </b-td>
                                <b-td>{{item.ModifierDesc}}</b-td>
                                <b-td>${{item.Price.toFixed(2)}}</b-td>
                                <b-td>
                                    <font-awesome-icon class="cursor-pointer align-middle" icon="pencil-alt" />
                                </b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                    <div v-else class="text-center">
                        <span class="text-danger">No modifier</span>
                    </div>

                    <div v-if="editMode">
                        <b-input-group prepend="Modifier name" class="my-3">
                            <b-input v-model="model.ModifierName" name="Modifier name" v-validate="'required'"/>
                        </b-input-group>
                        <b-input-group v-if="AllowSecondLang" prepend="Second Language Modifier name" class="my-3">
                            <b-input name="ModifierName_SecondLang" v-model="model.ModifierName_SecondLang"/>
                        </b-input-group>
                        <b-input-group prepend="Description" class="my-3">
                            <b-input v-model="model.ModifiertDESC" name="Description"/>
                        </b-input-group>
                        <b-input-group prepend="Add'l Price ($)" class="my-3">
                            <b-input v-model="model.Price" type="number" name="Add'l Price" v-validate="'decimal|min_value:0'"/>
                        </b-input-group>
                        <b-alert :show="errors.any()" variant="danger" class="px-4 my-3">
                            <ul class="m-0 px-1">
                                <li v-for="err in errors.all()" :key="err">{{err}}</li>
                            </ul>
                        </b-alert>

                        <b-row class="flex-grow-1">
                            <b-col cols="4">
                                <b-btn variant="warning" block class="text-nowrap" :disabled="loading" @click="editModifier">
                                    <span v-if="!loading">Save Changes</span>
                                    <font-awesome-icon v-else spin icon="circle-notch" class="align-middle"/>
                                </b-btn>
                            </b-col>
                            <b-col cols="4">
                                <b-btn variant="danger" block class="text-nowrap cancel-btn-cmodal" :disabled="progressing" @click="cancelEditMode">
                                    Cancel
                                </b-btn>
                            </b-col>
                            <b-col cols="4">
                                <b-btn variant="danger" block class="text-nowrap" @click="deleteModifier(selectedModifierID)">
                                    Delete Modifier
                                </b-btn>
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import Multiselect from '../shared/multiselect'

    export default {
        name: "editModifierOption",
        components: {
            Multiselect
        },
        props: {
            AllowSecondLang: {
                required: false
            },
            selectedCategoryID: {
                required: true
            },
            selectedModifierName: {
                required: true
            },
            selectedModifierOptional: {
                required: true
            },
            selectedModifierChoiceNumber: {
                required: true
            },
            selectedModifierChoiceOption: {
                required: true
            },
            modeType: {
                required: true
            }
        },
        data () {
            return {
                model: {
                    Price: null,
                    ModifiertDESC: null,
                    ModifierName: null,
                    ModifierName_SecondLang: '',
                },
                Modifiers: [],
                currentModifier: [],
                editMode: false,
                selectedModifierID: null,
                loading: false
            }
        },
        mounted() {
            this.getAllModifiers()
            this.getCurrentModifer()
        },
        methods: {
            getAllModifiers() {
                let model = {
                    // UserID: localStorage.getItem('userID'),
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    CategoryID: -1,
                    ModifierID: -1,
                    ModifierType: this.modeType
                }
                return this.$api.getRestaurant.GetRestaurantModifier(model).then(res => {
                    if (res.success) {
                        let results = res.results.RestaurantMidifierAll
                        results.forEach(item => {
                            item.value = item.ModifierID
                            item.name = item.ModifierName
                        })
                        this.Modifiers = results
                    }
                })
            },
            getCurrentModifer () {
                //get currnet modifier option for selected modifer group
                let model = {
                    // UserID: localStorage.getItem('userID'),
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    CategoryID: this.selectedCategoryID,
                    ModifierID: -1,
                    ModifierType: this.modeType
                }
                return this.$api.getRestaurant.GetRestaurantModifier(model).then(res => {
                    if (res.success) {
                        let results = res.results.RestaurantMidifierAll
                        results.forEach(item => {
                            item.selected = false
                        })
                        this.currentModifier = results.map((item => ({...item})))
                    }
                })
            },
            editModifier () {
                //edit modifer option
                this.$validator.validateAll().then(res => {
                    if (res) {
                        let model = {
                            // UserID: localStorage.getItem('userID'),
                            RestaurantID: this.$store.state.selectedRestaurantId,
                            ModifierCategoryID: this.selectedCategoryID,
                            ModifierID: this.selectedModifierID,
                            ModifierType: this.modeType,
                            Price : this.model.Price,
                            ModifierName: this.model.ModifierName,
                            ModifiertDESC: this.model.ModifiertDESC,
                            ModifierName_SecondLang: this.model.ModifierName_SecondLang.trim(),
                        }
                        this.loading = true
                        this.$api.getRestaurant.UpdateModifier(model).then(res => {
                            if (res.success) {
                                this.getCurrentModifer()
                                this.editMode = false
                                this.loading = false
                                this.$emit('changeModifier', '')
                            } else {
                                this.$showError(res.message)
                                this.loading = false
                            }
                        }).catch(() => {
                            this.loading = false
                        })
                    }
                })
            },
            selectModifer(item) {
                // set value to form inputs by seleceted any modifer
                this.currentModifier.forEach(item => {
                    item.selected = false
                })
                item.selected = !item.selected
                this.model.Price = item.Price
                this.model.ModifiertDESC = item.ModifierDesc
                this.model.ModifierName = item.ModifierName
                this.model.ModifierName_SecondLang = item.ModifierName_SecondLang
                this.selectedModifierID = item.ModifierID
                this.editMode = true
            },
            deleteModifier (ModifierID) {
                //delete modifier option
                // this.selectedModifierID = item.ModifierID
                this.$showConfirm(undefined, 'Are You Sure To Remove This Item??').then(() => {
                    let model = {
                        // UserID: localStorage.getItem('userID'),
                        RestaurantID: this.$store.state.selectedRestaurantId,
                        ModifierCategoryID: this.selectedCategoryID,
                        ModifierID,
                        ModifierType: this.modeType,
                        Price : this.model.Price,
                        ModifierName: this.model.ModifierName,
                        ModifiertDESC: this.model.ModifiertDESC,
                        Action: 'DEL'
                    }

                    this.$api.getRestaurant.UpdateModifierCategoryRelation(model).then((res) => {
                        if (res.success) {
                            this.editMode = false

                            this.$emit('changeModifier', '')
                            this.getCurrentModifer()

                        }
                    })
                })
            },
            cancelEditMode () {
                this.currentModifier.forEach(item => {
                    item.selected = false
                })
                this.editMode = false
            }
        }
    }
</script>

<style scoped>
    .selectedModifier{
        border: 5px solid rgb(180, 255, 28) !important;
    }
</style>
